<template>
    <div class="user">
        <!--搜索表单-->
        <div class="common-seach-wrap"> </div>

        <div class="goods-content">
            <el-form ref="form" :model="form" label-width="100px">
                <div class="table-wrap">
                    <el-table v-loading="loading" size="small" :data="tableData" border style="width: 100%">
                        <el-table-column prop="goods_name" label="商品名称" width="360">
                            <template slot-scope="scope">
                                <div class="goods-info">
                                    <div class="pic" style="width: 40px; height: 40px;"><img v-img-url="scope.row.goods.image[0].file_path" alt=""/></div>
                                    <div class="info">
                                        <div class="name">{{ scope.row.goods.goods_name }}</div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="active.title" label="活动名称"></el-table-column>
                        <el-table-column prop="stock" label="库存"></el-table-column>
                        <el-table-column prop="limit_num" label="限购数量"></el-table-column>
                        <el-table-column prop="total_sales" label="累计销量"></el-table-column>
                        <el-table-column prop="join_num" label="参与人数"></el-table-column>
                        <el-table-column prop="status_text" label="状态"></el-table-column>
                        <el-table-column prop="remark" label="备注"></el-table-column>
                        <el-table-column prop="create_time" label="申请时间"></el-table-column>
                        <el-table-column fixed="right" label="操作" width="90">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="edit(scope.row)">修改</el-button>
                                <el-button v-if="scope.row.status != 10" type="text" size="small" @click="delClick(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-form>
            <!--分页-->
            <div class="pagination">
                <el-pagination
                    background
                    :current-page="curPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="totalDataNumber"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import AssembleApi from "@/api/assemble";
    export default {
        data() {
            return {
                formInline: {},
                form: {},
                tableData: [],
                /*一页多少条*/
                pageSize: 20,
                /*一共多少条数据*/
                totalDataNumber: 0,
                /*当前是第几页*/
                curPage: 1,
                /*是否加载完成*/
                loading: true
            };
        },
        created() {
            /*获取列表*/
            this.getData();
        },
        methods: {
            /*获取列表*/
            getData() {
                let self = this;
                let Params = {};
                Params.page = self.curPage;
                Params.list_rows = self.pageSize;
                AssembleApi.myList(Params, true)
                    .then((data) => {
                        self.loading = false;
                        self.tableData = data.data.list.data;
                        self.totalDataNumber = data.data.list.total;
                    })
                    .catch((error) => {});
            },
            /*选择第几页*/
            handleCurrentChange(val) {
                let self = this;
                self.curPage = val;
                self.loading = true;
                self.getData();
            },

            /*每页多少条*/
            handleSizeChange(val) {
                this.curPage = 1;
                this.pageSize = val;
                this.getTableList();
            },
            edit(row) {
                this.$router.push("/activity/assemble/edit?assemble_goods_id=" + row.assemble_goods_id);
            },
            /*删除*/
            delClick: function(row) {
                let self = this;
                self.$confirm("删除后不可恢复，确认删除该记录吗?", "提示", {
                    type: "warning"
                }).then(() => {
                    AssembleApi.delGoods({
                        assemble_goods_id: row.assemble_goods_id
                    }).then((data) => {
                        self.$message({
                            message: "删除成功",
                            type: "success"
                        });
                        self.getData();
                    });
                });
            }
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/activity/assemble/my.vue